import { Chatbot } from "../../../../features/Chatbot";
import { ChatbotPage } from "../../../../pages/ChatbotPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const chatbotPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.ai_agents_telegram_bots.root,
  element: <ChatbotPage />,
  name: "Телеграм-боты",
  children: appRouterPaths.ai_agents_telegram_bots.item
    ? [
        {
          path: appRouterPaths.ai_agents_telegram_bots.item,
          element: <Chatbot />,
          name: "телеграм-бот",
        },
      ]
    : undefined,
};
